import { render, staticRenderFns } from "./ManageCertificate.vue?vue&type=template&id=70157396&scoped=true&"
import script from "./ManageCertificate.vue?vue&type=script&lang=js&"
export * from "./ManageCertificate.vue?vue&type=script&lang=js&"
import style0 from "./ManageCertificate.vue?vue&type=style&index=0&id=70157396&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70157396",
  null
  
)

export default component.exports